import React from 'react'

export default function CoursePlayer() {
  return (
    <div>CoursePlayer</div>
  )
}
